// generated by bun run generate from the SwiftUI SDK and codegen/catalog.ts.
// edit the generator or catalog, then regenerate.
import type { ViewProps } from 'react-native';
import type { Int32 } from 'react-native/Libraries/Types/CodegenTypes';
import codegenNativeComponent from 'react-native/Libraries/Utilities/codegenNativeComponent';
interface NativeProps extends ViewProps {
  animatorId: Int32;
  animations: string;
  hasTrigger: boolean;
  trigger: Int32;
}
const NativeComponentRegistry = require('react-native/Libraries/NativeComponent/NativeComponentRegistry');
let nativeComponentName = 'OneNativePhaseAnimator';
export const __INTERNAL_VIEW_CONFIG = {
  uiViewClassName: "OneNativePhaseAnimator",
  validAttributes: {
    animatorId: true,
    animations: true,
    hasTrigger: true,
    trigger: true
  }
};
export default NativeComponentRegistry.get(nativeComponentName, () => __INTERNAL_VIEW_CONFIG);